const e = {
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "90em"
};
export {
  e as default
};
